import { NumericQuestion } from "./numeric-question";
import type { QuestionTypeRendererProps } from "./shared";

type NumberQuestionProps = QuestionTypeRendererProps<"number">;

export default function NumberQuestionType(props: NumberQuestionProps) {
  return <NumericQuestion {...props} kind="number" />;
}
